module.exports = __webpack_public_path__ + "static/media/Mr_thy.910b922f.png";